import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root');

import KeyWatcher from '../../hocs/KeyWatcher';

import ModalHeader from './modal/ModalHeader';
import ModalBody from './modal/ModalBody';
import ModalFooter from './modal/ModalFooter';


class Modal extends Component {
    constructor (props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount () {
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount () {
        modalRoot.removeChild(this.el);
    }

    render () {
        let { cancelModal, saveAction, type } = this.props;

        function recursiveCloneChildren (children) {
            return React.Children.map(children, child => {
                var childProps = (React.isValidElement(child)) ? {
                    cancelModal: cancelModal,
                    saveAction: saveAction,
                    modalType: type
                } : {};

                if (React.isValidElement(child) && child.props) {
                    childProps.children = recursiveCloneChildren(
                        child.props.children
                    );
                    return React.cloneElement(child, childProps);
                }
                return child;
            });
        }

        const childrenWithProps = recursiveCloneChildren(this.props.children);

        return ReactDOM.createPortal(<div className="invintus-modal">
            <div className="invintus-modal-content clearfix">
                {childrenWithProps}
            </div>
        </div>, this.el);
    }
}

const ModalWithKeyWatcher = KeyWatcher(
    Modal
);

ModalWithKeyWatcher.Header = ModalHeader;
ModalWithKeyWatcher.Body = ModalBody;
ModalWithKeyWatcher.Footer = ModalFooter;

export default ModalWithKeyWatcher;
